export { default } from "bullitttime-embermodelsevent/models/event";
